export default __webpack_public_path__ + "static/media/direction.73c96278.svg";